import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import defer from 'lodash/defer';
import { TextField } from '../text-field/TextField';
import autobind from '../_util/autobind';
import Icon from '../icon';
// let selectionStart;
// let selectionEnd;
let Password = class Password extends TextField {
    constructor() {
        super(...arguments);
        this.type = 'password';
    }
    get multiple() {
        return false;
    }
    get range() {
        return false;
    }
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'reveal',
        ]);
    }
    getOtherPrevNode() {
        return React.createElement("input", { tabIndex: -1, className: `${this.prefixCls}-fix-autofill` });
    }
    getInnerSpanButton() {
        const { reveal } = this.props;
        if (reveal && !this.disabled) {
            return this.wrapperInnerSpanButton(React.createElement(Icon, { type: this.reveal ? 'visibility' : 'visibility_off', onClick: this.handleToggleReveal }), {
                style: { right: this.lengthInfoWidth },
            });
        }
    }
    select() {
        if (!this.revealIconFocus) {
            super.select();
        }
    }
    handleFocus(e) {
        super.handleFocus(e);
        defer(() => {
            if (this.revealIconFocus) {
                this.revealIconFocus = false;
            }
        });
    }
    handleToggleReveal(e) {
        e.preventDefault();
        const target = this.element;
        if (target) {
            if (target.type === 'password') {
                this.doReveal(target);
            }
            else {
                this.resetReveal(target);
            }
        }
        if (!this.isFocused) {
            this.revealIconFocus = true;
            target.focus();
        }
        defer(() => target.setSelectionRange(-1, -1));
    }
    doReveal(target) {
        target.type = 'text';
        this.type = target.type;
        this.reveal = true;
    }
    resetReveal(target) {
        target.type = 'password';
        this.type = target.type;
        this.reveal = false;
    }
};
Password.displayName = 'Password';
Password.defaultProps = {
    ...TextField.defaultProps,
    suffixCls: 'password',
    reveal: true,
};
__decorate([
    observable
], Password.prototype, "reveal", void 0);
__decorate([
    autobind
], Password.prototype, "handleFocus", null);
__decorate([
    autobind
], Password.prototype, "handleToggleReveal", null);
__decorate([
    action
], Password.prototype, "doReveal", null);
__decorate([
    action
], Password.prototype, "resetReveal", null);
Password = __decorate([
    observer
], Password);
export default Password;
